<template>
  <div>
    <TitlePage :title="$t('create')+' '+$t('sportCenter')"></TitlePage>

    <v-layout wrap>

      <v-flex md12 class="d-flex">
        <v-chip color="primary" label small text-color="white">{{$t('genericInfo')}}</v-chip>
      </v-flex>

      <v-flex md5 class="pl-4 pr-4">
        <v-text-field :label="$t('name')" v-model="item.name" :rules="validation.textRules" :error-messages="errors.name" @change="makeSlug" @input="makeSlug"></v-text-field>
      </v-flex>

      <v-flex md5 class="pl-4 pr-4">
        <v-text-field :label="$t('slug')" v-model="item.slug" :rules="validation.textRules" :error-messages="errors.slug"></v-text-field>
      </v-flex>

      <v-flex md2 class="pl-4 pr-4">
        <v-switch v-model="item.active" inset :label="$t('status')" dense hide-details></v-switch>
      </v-flex>

      <v-flex md12 class="pl-4 pr-4">

        <v-autocomplete
            id="map"
            prepend-icon="mdi-map-marker"
            v-model="item.address_complete" :items="google_places_results" :loading="google_places_loading"
            :search-input.sync="google_places_search" hide-no-data hide-selected disable-lookup :placeholder="$t('addressComplete')"
            clearable return-object :rules="validation.textRules" no-filter @change="setResult"
        ></v-autocomplete>
      </v-flex>

      <v-flex md12 class="d-flex pt-5">
        <v-chip color="primary" label small text-color="white">{{$t('companyInfo')}}</v-chip>
      </v-flex>

      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('company')" v-model="item.company_info.company" @input="copyToFinancial" @change="copyToFinancial"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('address')" v-model="item.company_info.address"></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('city')" v-model="item.company_info.city"></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('province')" v-model="item.company_info.province"></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('postal_code')" v-model="item.company_info.postal_code"></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('country')" v-model="item.company_info.country"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('phone')" v-model="item.company_info.phone"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('email')" v-model="item.company_info.email"></v-text-field>
      </v-flex>

      <v-flex md12 class="d-flex pt-5">
        <v-chip color="primary" label small text-color="white">{{$t('financialInfo')}}</v-chip>
      </v-flex>

      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('company')" v-model="item.financial_info.company"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('address')" v-model="item.financial_info.address"></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('city')" v-model="item.financial_info.city"></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('province')" v-model="item.financial_info.province"></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('postal_code')" v-model="item.financial_info.postal_code"></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('country')" v-model="item.financial_info.country"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('vat_code')" v-model="item.financial_info.vat_code"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('fiscal_code')" v-model="item.financial_info.fiscal_code"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('sdi_code')" v-model="item.financial_info.sdi_code"></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('pec_address')" v-model="item.financial_info.pec_address"></v-text-field>
      </v-flex>

      <v-flex md12 class="d-flex pt-5">
        <v-chip color="primary" label small text-color="white">{{$t('settings')}} {{$t('PromoCode')}}</v-chip>
      </v-flex>

      <v-flex md2 class="pl-4 pr-4">
        <v-checkbox
            v-model="item.enable_promo_code_promo_sa_global"
            label="Accetta Promo Code uCamp"
            :readonly="!this.getUser.super_admin"
            :disabled="!this.getUser.super_admin"
        ></v-checkbox>
      </v-flex>

      <v-flex md2 class="pl-4 pr-4">
        <v-checkbox
            v-model="item.enable_promo_code_promo_center"
            label="Accetta Promo Code Centro"
        ></v-checkbox>
      </v-flex>

      <v-flex md12 class="d-flex pt-5 pb-5">
        <v-checkbox v-model="item.admin.create" :label="$t('createNewAdmin')" color="primary" hide-details></v-checkbox>
      </v-flex>

      <template v-if="item.admin.create">

        <v-flex md12 class="d-flex pt-5">
          <v-chip color="primary" label small text-color="white">{{$t('adminCenter')}}</v-chip>
        </v-flex>

        <v-flex md6 class="pl-4 pr-4">
          <v-text-field :label="$t('name')" v-model="item.admin.full_name" :error-messages="errors.full_name"></v-text-field>
        </v-flex>
        <v-flex md6 class="pl-4 pr-4">
          <v-text-field :label="$t('email')" v-model="item.admin.email"  :error-messages="errors.email"></v-text-field>
        </v-flex>
        <v-flex md6 class="pl-4 pr-4">
          <v-text-field :label="$t('password')" v-model="item.admin.password_new"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword" :error-messages="errors.password"
          ></v-text-field>
        </v-flex>
        <v-flex md6 class="pl-4 pr-4">
          <v-switch v-model="item.admin.active" inset :label="$t('status')"></v-switch>
        </v-flex>
      </template>

      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="secondary" class="ml-auto" @click="save" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-2" @click="save(true)" type="submit">
          {{ $t('saveAndGoToFields') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
const slugify = require('slugify')

export default {
  name: "CreateCenter",
  components: {TitlePage},
  data() {
    return {
      google_places_results: [],
      google_places_loading: false,
      google_places_search: '',
      google_places_service: null,
      detail_google_places_service: null,
      showPassword:false,
      item: {
        name: '',
        slug: '',
        address_complete: "",
        position:{
          type: "",
          coordinates:[]
        },
        company_info: {
          company: "",
          address: "",
          city: "",
          province: "",
          postal_code: "",
          country: "",
          phone: "",
          email: ""
        },
        financial_info: {
          company: "",
          address: "",
          city: "",
          province: "",
          postal_code: "",
          country: "",
          vat_code: "",
          fiscal_code: "",
          sdi_code: "",
          pec_address: ""
        },
        active: false,
        settings: {},
        logo: "",
        services:[],
        followers_count: 0,
        media:[],
        review_avg: 0.00,
        review_count: 0,
        rules: '',
        summary: '',
        enable_promo_code_promo_sa_global: false,
        enable_promo_code_promo_center: false,
        admin: {
          create: false,
          full_name: '',
          email: '',
          password_new: '',
          active: false
        }
      },
      check: true,
      errors:{
        name: '',
        slug: '',
        address_complete: '',
        full_name: '',
        email: '',
        password_new:'',
      },
      validation: {
        textRules: [
          v => !!v || this.$t('fillMandatory'),
        ],
        email: [
          v => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(v) || this.$t('emailNotValid')
          }
        ],
      }
    };
  },
  computed: {
    ...mapGetters({
      'getEndpoint': 'settings/getEndpoint',
      'getUser':'user/getUser'
    }),
  },
  watch: {
    google_places_search (newValue) {
      if (newValue && newValue.length >= 3 && !this.google_places_loading) {
        this.google_places_loading = true
        this.google_places_service.getPlacePredictions({
          input: this.google_places_search,
          types: ['address'],
          language: 'it',
          componentRestrictions: {
            country: 'it'
          },
        }, this.displaySuggestions)
      }
    }
  },
  async created(){
    if(!this.getUser.super_admin){
      this.$router.push('/')
      return
    }
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'storeItem': 'centers/store'
    }),

    async setResult(){

      let address = JSON.parse(JSON.stringify(this.item.address_complete))
      this.item.address_complete = this.item.address_complete.text

      var geocoder = new google.maps.Geocoder();
      var result_geocoder = await geocoder.geocode({placeId:address.id})

      if(result_geocoder.results[0].address_components.length > 0){

        let placeResultData = result_geocoder.results[0]
        let country
        let city
        let province
        let postal_code
        let street
        let number

        for(let c of placeResultData.address_components){
          if(c.types.includes('country')){
            country = c.short_name
          }else if(c.types.includes('locality')){
            city = c.long_name
          }else if(c.types.includes('administrative_area_level_2')){
            province = c.short_name
          }else if(c.types.includes('postal_code')){
            postal_code = c.long_name
          }else if(c.types.includes('street_number')){
            number = c.short_name
          }else if(c.types.includes('route')){
            street = c.long_name
          }
        }

        this.item.position.type = "Point"
        this.item.position.coordinates = [
          placeResultData.geometry.location.lng(),
          placeResultData.geometry.location.lat()
        ]


        let address_info = (number) ? street+','+number : street

        this.item.company_info.address = address_info
        this.item.company_info.city = city
        this.item.company_info.province = province
        this.item.company_info.postal_code = postal_code
        this.item.company_info.country = country

        this.item.financial_info.address = address_info
        this.item.financial_info.city = city
        this.item.financial_info.province = province
        this.item.financial_info.postal_code = postal_code
        this.item.financial_info.country = country

      }

    },

    displaySuggestions (predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {

        this.google_places_results = []
        this.google_places_loading = false

      }else {

        this.google_places_results = []
        predictions.map((x) => {
          this.google_places_results.push({
            'text': x.description,
            'id': x.place_id
          })
        })
        this.google_places_loading = false

      }
    },

    async save(redirect = false){

      await this.checkItem()
      if(!this.check){
        return
      }else {
        await this.resetError()
      }


      await this.setLoading(true);
      var result = await this.storeItem(this.item)
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('createSuccess')
        })

        if(!redirect){
          await this.$router.push('/centers/')
        }else {
          await this.$router.push(`/fields/create/?center_id=${result.result.result._id}`)
        }

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

    async checkItem(){

      this.check = true

      if(!this.item.name){
        this.check = false
        this.errors.name = this.$t('fillMandatory');
      }

      if(!this.item.slug){
        this.check = false
        this.errors.slug = this.$t('fillMandatory');
      }

      if(!this.item.address_complete){
        this.check = false
        this.errors.address_complete = this.$t('fillMandatory');
      }

      if(!this.item.admin.full_name && this.item.admin.create){
        this.check = false
        this.errors.full_name = this.$t('fillMandatory');
      }

      if(!this.item.admin.email && this.item.admin.create){
        this.check = false
        this.errors.email = this.$t('fillMandatory');
      }

      if(!this.item.admin.password_new && this.item.admin.create){
        this.check = false
        this.errors.password_new = this.$t('fillMandatory');
      }

    },

    async makeSlug(){
      this.item.slug = slugify(this.item.name, {remove: /[*+~.()'"!:@,/]/g,lower: true, locale: 'it'})
    },
    copyToFinancial(){
      this.item.financial_info.company = this.item.company_info.company
    },

    async resetError(){
      this.errors = {
        name: '',
        slug: '',
        address_complete: '',
        full_name: '',
        email: '',
        password_new: ''
      }
    },

  },
  mounted() {
    this.google_places_service = new window.google.maps.places.AutocompleteService()
  },
}
</script>

<style>
.ck-editor__editable {
  min-height: 500px;
}

@media only screen and (max-width: 767px) {
  .buttons-group-mobile{
    width: 100%;
    flex-direction: column-reverse;
  }

  .buttons-group-mobile .v-btn{
    width: 100%;
    margin: 5px !important;
    padding: 0 !important;
  }
}

</style>